import React from 'react'
import { AboutParagraph, AboutTabWrapper, AboutText, AboutTextWrapper, OpeningHoursContainer, OrderCardWrapperContainer, OrderCardWrapperContainerABOUT } from './Theme14ExtStyleComponent'

const TabAbout = (props) => {
  let colordata = props?.colordata;
  return (
    <OrderCardWrapperContainerABOUT>
    <OpeningHoursContainer style={{background: colordata?.dynamicBackgroundColor || ""}}>
    <AboutTextWrapper>
      {/* <AboutText>About</AboutText> */}
      <AboutParagraph dangerouslySetInnerHTML={{ 
        __html: props?.rs?.description?.replace(/(?:\r\n|\r|\n)/g, '<br>') 
      }} style={{color: colordata?.dynamicTextDescriptionColor || ""}}>
      </AboutParagraph>
    </AboutTextWrapper>
  
    </OpeningHoursContainer>
     </OrderCardWrapperContainerABOUT>
  )
}

export default TabAbout